import { useEffect } from 'react';
import { pushAnalyticsEvent } from 'helpers/analytics';

const usePageTitle = (pageName: string) => {
  useEffect(() => {
    document.title = `${pageName} | Zillionaires’ Club | Zizzi`;
    pushAnalyticsEvent({ event: 'virtualPageview' });
  }, [pageName]);
};

export default usePageTitle;
